import React from 'react';
import { TooltipHost, DirectionalHint, Icon } from '@fluentui/react';

export const AllowEditAfterApprovalColumnHeader: React.FC = () => (
    <TooltipHost
        content="When enabled, approval rows for this activity can be edited even after they have been approved. This is useful for scenarios like deferred invoicing where adjustments may be needed after initial approval."
        directionalHint={DirectionalHint.topCenter}
        styles={{ root: { display: 'inline-flex', alignItems: 'center', gap: 4 } }}
    >
        <span>Allow Edit After Approval</span>
        <Icon iconName="Info" styles={{ root: { fontSize: 12, color: '#605e5c' } }} />
    </TooltipHost>
);
